import script from "./NewsPageStoryNatureSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageStoryNatureSelector.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageStoryNatureSelector.vue?vue&type=style&index=0&id=6e8bfd86&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e8bfd86"]])

export default __exports__